// extracted by mini-css-extract-plugin
export default {"active":"subTab__active-qnxp6","container":"subTab__container-NlE0I","gray2":"subTab__gray2-LTUAJ","blue":"subTab__blue-quAt4"};